module.exports = __webpack_public_path__ + "img/donations-back.45a2ebc2.jpg";